import React from 'react';
import { t } from '../utils/i18n';

export function statusTone(value) {
  if (['SUCCESS', 'APPROVED', 'PASSED', 'COMMITTED', 'MERGED', 'RELEASED', 'READY', 'NOT_NEEDED'].includes(value)) return 'success';
  if (['FAILED', 'CHANGES_REQUESTED', 'ERROR'].includes(value)) return 'danger';
  if (['PENDING', 'DRAFT', 'PLANNING', 'UNDER_REVIEW', 'WAITING'].includes(value)) return 'warning';
  return 'neutral';
}
export function statusLabel(value) {
  const text = t(`adminUi.statuses.${value || 'UNKNOWN'}`);
  return text.startsWith('adminUi.statuses.') ? value || t('adminUi.unknown') : text;
}
export default function StatusBadge({ value }) {
  return <span className={`admin-status-badge admin-status-${statusTone(value)}`}>{statusLabel(value)}</span>;
}
